import api_1_2_0 from './1.2.0.yaml';
import api_1_1_0 from './1.1.0.yaml';
import api_1_0_0 from './1.0.0.yaml';

const versions = [
  { name: '1.2.0', yaml: api_1_2_0 },
  { name: '1.1.0', yaml: api_1_1_0 },
  { name: '1.0.0', yaml: api_1_0_0 }
];

export default versions;
